import type { BranchTagsMiniEntity } from './BranchTagsMiniEntity'

export class BranchTagsResponseEntity {
  readonly remainingItems?: number
  count?: number
  readonly page?: number
  readonly limit?: number
  readonly metadata?: unknown
  items?: Array<BranchTagsMiniEntity> | null
}
